<template>
    <div>
        <user-header :standardMap="creatorGallery.standardMap" />
        <div class="p-3 text-center bg-white rounded border">
            <gallery-details :creatorGallery="creatorGallery" />
            <gallery-preview :creatorGallery="creatorGallery" />

            <div class="my-4">
                <div class="d-flex align-items-center justify-content-center">
                    <font-awesome-icon
                        icon="fa-duotone fa-coin"
                        size="lg"
                        class="small-avatar mr-2 text-warning"
                    />
                    <h1 class="text-warning mb-0">
                        {{ creatorGallery.price }}
                        {{ $t("credits") }}
                    </h1>
                </div>

                <div class="text-secondary">
                    {{ $t("One-time payment to unlock") }}
                </div>
            </div>

            <div class="mt-3">
                <b-btn
                    @click="viewGallery"
                    variant="primary"
                    size="lg"
                    block
                    pill
                >
                    <h3 class="mb-0">
                        {{ $t("Purchase Gallery") }}
                    </h3>

                    <b-badge
                        v-if="isSubscribed"
                        variant="success"
                        pill
                        class="mt-2 p-2 px-3"
                    >
                        <coin-badge
                            class="mx-1"
                            :amount="creatorGallery.discountedPrice"
                        />
                        {{ $t("50% Subscriber Discount") }}
                    </b-badge>
                </b-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import UserHeader from "@/components/userHeader/UserHeader";

import GalleryPreview from "@/components/gallery/GalleryPreview";
import GalleryDetails from "@/components/gallery/GalleryDetails";

export default {
    computed: {
        isSubscribed() {
            return this.subscribedToCreatorUserId(this.creatorGallery.userId);
        },
        ...mapState("gallery", ["creatorGallery"]),
        ...mapGetters("creatorSubscription", [
            "subscribedToCreatorUserId",
            "canSubscribeToUserId",
        ]),
    },
    methods: {
        viewGallery() {
            this.$store.dispatch("gallery/unlock");
        },
    },
    components: {
        UserHeader,
        GalleryPreview,
        GalleryDetails,
    },
};
</script>